import Vue from 'vue'
import App from './App.vue'
import components from './components';

//Set global constants
Vue.prototype.$Loading = 'loading';
Vue.prototype.$Intro = 'intro';
Vue.prototype.$MainLanding = 'mainLanding';
Vue.prototype.$HomeFamily = 'homeFamily';
Vue.prototype.$QuestionSet = 'questionSet';
Vue.prototype.$Share = 'share';
Vue.prototype.$ShareForm = 'shareForm';

Vue.config.productionTip = false

new Vue({
  components,
  render: h => h(App),
}).$mount('#app')
